export * from './globals';
export * from './configs';
export * from './mock';
export { TRANSLATIONS as TRANSLATIONS_IT } from './translations/it';
export { TRANSLATIONS as TRANSLATIONS_EN } from './translations/en';
export * from './version';



// WEBPACK FOOTER //
// ./src/app/constants/index.ts